import ProductDescription from './ProductDescription'

const WWBagelsProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '010',
  IsBroadband: true,
  Size: '',
  WholeWheatCert: false,
}

export default WWBagelsProduct
